.scrim {
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  inset: 0;
  justify-content: center;
  padding: var(--pgm-sys-spacing-4);
  position: fixed;
  z-index: 1100;
}

.dialog {
  background-color: var(--pgm-sys-color-surface-container-lowest);
  border-radius: 20px;
  box-shadow: var(--pgm-sys-elevation-level3);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-4);
  max-height: 90vh;
  overflow-y: auto;
  padding: var(--pgm-sys-spacing-6);
  width: 100%;
}

.dialogSmall {
  max-width: 400px;
}

.dialogMedium {
  max-width: 560px;
}

.dialogLarge {
  max-width: 760px;
}

.header {
  align-items: center;
  display: flex;
  gap: var(--pgm-sys-spacing-3);
}

.icon {
  color: var(--pgm-sys-color-primary);
  font-size: 32px;
  line-height: 1;
}

.title {
  color: var(--pgm-sys-color-on-surface);
  flex: 1;
  margin: 0;
}

.content {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-3);
  color: var(--pgm-sys-color-on-surface-variant);
}

.actions {
  display: flex;
  gap: var(--pgm-sys-spacing-2);
  justify-content: flex-end;
}

@media (max-width: 600px) {
  .dialog {
    padding: var(--pgm-sys-spacing-4);
  }

  .actions {
    justify-content: stretch;
  }
}
